// extracted by mini-css-extract-plugin
module.exports = {"buttonText":"#999","buttonBg":"#fff","buttonActiveText":"#fff","buttonActiveBg":"#4d6ef6"};